export default __webpack_public_path__ + "static/media/menu-mobile-close.23ee90ba.svg";